<!--TODO:

/Force-Device-Scale-Factor=1.00 /Start-URL "http://localhost:8081"
-->
<template>
  <div class="container">
    <!-- Invoerkolom -->
    <div class="column">
      <div class="column1">
        <label for="generalSettings">{{ getTranslation('inputAdvise','generalSettings') }}</label>
        <!-- Language Selection -->
        <select v-model="currentLanguage" @change="changeLanguage">
          <option value="en">English</option>
          <option value="de">Deutsch</option>
          <option value="fr">Français</option>
          <option value="es">Español</option>
          <option value="nl">Nederlands</option>
        </select>
        <!-- Unit System Selection -->
        <div class="input-container col-12">
          <label for="unitSystemSelect">{{ getTranslation('inputAdvise','unitSystem') }}:</label>
          <select v-model="inputData.unitSystem" id="unitSystemSelect">
            <option disabled value="">{{ getTranslation('inputAdvise','select') }}</option>
            <option value="metric">{{ getTranslation('unit','metric') }}</option>
            <option value="imperial">{{ getTranslation('unit','imperial') }}</option>
          </select>
        </div>
        <!-- Mail Input
        <div class="input-container col-12">
          <label for="mailInput">{{ getTranslation('inputAdvise','mailInput') }}:</label>
          <input type="text"
            v-model.number="inputData.mail"
            class="square-input"
            name="text">
        </div>-->
      </div>
      <div class="column1">
      <label for="machineSettings">{{ getTranslation('inputAdvise','machineSettings') }}</label>
      <!-- Machine Type Dropdown -->
        <div class="input-container col-12">
          <label for="machineTypeSelect">{{ getTranslation('inputAdvise','machineType') }}:</label>
          <select v-model="inputData.machine_type" id="machineTypeSelect">
            <option disabled value="">{{ getTranslation('inputAdvise','select') }}</option>
            <option v-for="machine in machineTypes" :key="machine" :value="machine">
              {{ machine }}
            </option>
          </select>
        </div>

        <div class="input-container col-12">
          <label for="yearOfManufacture">{{ getTranslation('inputAdvise','yearOfManufacture') }}:</label>
          <select v-model="inputData.yearOfManufacture" id="yearOfManufacture">
            <option disabled value="">{{ getTranslation('inputAdvise','select') }}</option>
            <option v-for="year in years" :key="year" :value="year">
              {{ parseInt(year) }}
            </option>
          </select>
        </div>

        <div class="input-container col-12">
          <label for="machineTypeSelect">{{ getTranslation('inputAdvise','downstreamUnits') }}:</label>
          <div class="button-group">
            <button :class="['button',{ active: inputData.SCD }]" @click="toggleSelection('SCD')">SCD</button>
            <button :class="['button',{ active: inputData.BMS }]" @click="toggleSelection('BMS')">BMS</button>
            <button :class="['button',{ active: inputData.TCM }]" @click="toggleSelection('TCM')">TCM</button>
            <button :class="['button',{ active: inputData.SCR }]" @click="toggleSelection('SCR')">SCR</button>
          </div>
        </div>

        <!-- Drumsize TCM -->
        <div v-if="inputData.TCM" class="drumsize-question">
          <div class="input-container col-12">
            <label for="drumsizeSelect">{{ getTranslation('inputAdvise','drumSize') }}:</label>
            <select v-model="inputData.tcmDrum" id="drumsizeSelect">
              <option disabled value="">{{ getTranslation('inputAdvise','select') }}</option>
              <option :value="parseInt('40')">40</option>
              <option :value="parseInt('60')">60</option>
              <option :value="parseInt('90')">90</option>
            </select>
          <span class="input-unit">{{ unitLabel }}</span>
          </div>
        </div>

        <!-- Aantal producten tegelijkertijd Input -->
        <div class="input-container col-12">
          <label for="numberOfStartingLengthsInput">{{ getTranslation('inputAdvise','productSimultaneously') }}:</label>
          <input type="number"
            v-model.number="inputData.numberOfStartingLengths"
            class="square-input"
            name="value">
        </div>
        <div v-if="errorMessageToManyStartingLengths" class="error-message">
          {{ errorMessageToManyStartingLengths }}
        </div>
        <div v-if="errorMessageToManyStartingLengthsSG" class="error-message">
          {{ errorMessageToManyStartingLengthsSG }}
        </div>
        <div v-if="errorMessageSCFInsufficentBundleLoaderSpeed" class="error-message">
          {{ errorMessageSCFInsufficentBundleLoaderSpeed }}
        </div>
      </div>

      <div class="column1">
        <label for="productSettings">{{ getTranslation('inputAdvise','productSettings') }}</label>
        <!-- Vorm buttons -->
        <div class="input-container col-12">
          <label>{{ getTranslation('inputAdvise','vorm') }}:</label>
          <button :class="['button',{ active: inputData.shape === 0 }]" @click="setShape(0)">{{ getTranslation('inputAdvise','round') }}</button>
          <button :class="['button',{ active: inputData.shape === 1 }]" @click="setShape(1)">{{ getTranslation('inputAdvise','square') }}</button>
          <button :class="['button',{ active: inputData.shape === 2 }]" @click="setShape(2)">{{ getTranslation('inputAdvise','rectangle') }}</button>
        </div>

        <!-- Massief Checkbox -->
        <div class="input-container col-12">
          <label for="checkbox">{{ getTranslation('inputAdvise','solid') }}:</label>
          <input type="checkbox" v-model="inputData.solid">
        </div>

        <!-- Diameter/Width Input -->
        <div class="input-container col-12">
          <label class="definition-name">{{ inputData.shape === 0 ? getTranslation('inputAdvise','diameter') : getTranslation('inputAdvise','width') }}:</label>
          <input type="number"
            v-model.number="inputData.width"
            class="square-input"
            :unit="inputData.unit"
            name="value">
          <span class="input-unit">{{ unitLabel }}</span>
        </div>

        <!-- Hoogte Input -->
        <div class="input-container col-12" v-if="inputData.shape !== 0">
          <label class="definition-name">{{ getTranslation('inputAdvise','height') }}:</label>
          <input type="number"
            v-model.number="inputData.height"
            class="square-input"
            :unit="inputData.unit"
            name="value">
          <span class="input-unit">{{ unitLabel }}</span>
        </div>
        <div v-if="errorMessageSCFSToBigTube" class="error-message">
          {{ errorMessageSCFSToBigTube }}
        </div>
        <div v-if="errorMessageSCFSToBigWidth" class="error-message">
          {{ errorMessageSCFSToBigWidth }}
        </div>
        <div v-if="errorMessageSCFSToBigHeight" class="error-message">
          {{ errorMessageSCFSToBigHeight }}
        </div>
        <div v-if="errorMessageSCFOToBigTube" class="error-message">
          {{ errorMessageSCFOToBigTube }}
        </div>
        <div v-if="errorMessageSCFOToBigWidth" class="error-message">
          {{ errorMessageSCFOToBigWidth }}
        </div>
        <div v-if="errorMessageSCFOToBigHeight" class="error-message">
          {{ errorMessageSCFOToBigHeight }}
        </div>

        <!-- Wanddikte Input, verborgen als massief is aangevinkt -->
        <div class="input-container col-12">
          <label v-if="!inputData.solid" for="wallInput">{{ getTranslation('inputAdvise','wallThickness') }}:</label>
          <input v-if="!inputData.solid"
            type="number"
            v-model.number="inputData.wall"
            class="square-input"
            :unit="inputData.unit"
            name="value">
          <span v-if="!inputData.solid" class="input-unit">{{ unitLabel }}</span>
            <!-- Display the error message if the diameter exceeds 90mm -->
        </div>

        <!-- Productlengte Input -->
        <div class="input-container col-12">
          <label for="productLengthInput">{{ getTranslation('inputAdvise','productLength') }}:</label>
          <input type="number"
            v-model.number="inputData.productLength"
            class="square-input"
            :unit="inputData.unit"
            name="value">
          <span class="input-unit">{{ unitLabel }}</span>
        </div>

        <!-- Startlengte Input -->
        <div class="input-container col-12">
          <label for="startLengthInput">{{ getTranslation('inputAdvise','startLength') }}:</label>
          <input type="number"
            v-model.number="inputData.startLength"
            class="square-input"
            :unit="inputData.unit"
            name="value">
          <span class="input-unit">{{ unitLabel }}</span>
        </div>

        <!-- Trimcut Lengte Input -->
        <div class="input-container col-12">
          <label for="trimLengthInput">{{ getTranslation('inputAdvise','trimcutLength') }}:</label>
          <input type="number"
            v-model.number="inputData.trimLength"
            class="square-input"
            :unit="inputData.unit"
            name="value">
          <span class="input-unit">{{ unitLabel }}</span>
        </div>

        <!-- Materiaal buttons -->
        <div class="input-container col-12">
          <label for="strengthSelect">{{ getTranslation('inputAdvise','selectMaterial') }}:</label>
          <div class="strengths-container">
            <button
              v-for="(strength, index) in getStrengths"
              :key="index"
              :class="['button',{ 'active': inputData.strength === index }]"
              @click="setStrength(index)">
              {{ strength }}
            </button>
          </div>
        </div>
      </div>

      <!-- Verzendknopke -->
      <div class="input-container button-container">
        <div v-if="errorMessageIncorrectData" class="timeout-message">
          {{ getTranslation('notify','incorrectData') }}
        </div>
        <div v-if="errorMessagestartLengthTooHeavy" class="timeout-message">
          {{ errorMessagestartLengthTooHeavy }}
        </div>
        <RoundButton @submit="submitData" :label="getTranslation('inputAdvise','getAdvise')" gradient="true"/>
      </div>
    </div>

    <!-- API Response Kolom -->
    <div class="column">
      <div v-if="isLoading" class="calculating-text">{{ getTranslation('ResponseAdvise','calculate') }}
        <div class="loader"></div>
      </div>
      <div v-else>
        <div v-if="response">
          <div v-if="NOadvise">
            <div class="response-content">
              <div class="response-table">
                <div class="response-row">
                  <div class="response-value hss-column">
                    <div class="response-key">{{ getTranslation('ResponseAdvise','resultHss') }}</div>
                    <div v-if="HSSadvise">
                      <div v-for="(value, key) in hssValues" :key="key" class="key-value-container">
                        <div class="key">{{ getTranslation('ResponseAdvise', key) }}:</div>
                        <div class="value">{{ value }} {{ getUnitForKey(key) }}</div>
                      </div>
                    </div>
                    <div v-else>{{ getTranslation('ResponseAdvise','noHss') }}</div>
                  </div>
                    <div class="response-value tct-column">
                      <div class="response-key">{{ getTranslation('ResponseAdvise','resultTct') }}</div>
                      <div v-if="TCTadvise">
                        <div v-for="(value, key) in tctValues" :key="key" class="key-value-container">
                          <div class="key">{{ getTranslation('ResponseAdvise', key) }}:</div>
                          <div class="value">{{ value }} {{ getUnitForKey(key) }}</div>
                        </div>
                      </div>
                      <div v-else>{{ getTranslation('ResponseAdvise','noTct') }}</div>
                    </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="response-key">{{ getTranslation('ResponseAdvise','noAdvise') }}</div>
          </div>
        </div>
        <div v-else>
          <div v-if="errorResponse">
            <div class="response-key">{{ getTranslation('ResponseAdvise','apiIresponsive') }}</div>
          </div>
          <div v-else>
            <div class="response-key">{{ getTranslation('ResponseAdvise','filInData') }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="disclaimer">
          <p>
            {{ getTranslation('Disclaimer','informatie') }} <a href="https://bewocs.tech/download-cutting-wizard-manual/" target="_blank">{{ getTranslation('Disclaimer','cuttinWizardManual') }}</a>.
          </p>
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios'
import RoundButton from "@/components/RoundButton.vue"
import RoundButtonWithInput from '@/components/RoundButtonWithInput.vue';
import ShapeSelector from "@/components/ShapeSelector.vue"
import LineChart from '@/components/LineChart.vue'
import enTranslations from "@/dist/en.json"
import deTranslations from "@/dist/de.json"
import frTranslations from "@/dist/fr.json"
import esTranslations from "@/dist/es.json"
import nlTranslations from "@/dist/nl.json"

export default {
  components: {
    RoundButton,
    ShapeSelector,
    RoundButtonWithInput,
    LineChart
  },
  data () {
    const isDevelopment = process.env.NODE_ENV === 'development';
    return {
      inputData: {
        unitSystem: 'metric',
        machine_type: 'SCF-Single',
        SCD: false,
        BMS: false,
        TCM: false,
        drumsize: '',
        SCR: false,
        shape: '',
        solid: false,
        width: '',
        height: '',
        wall: '',
        strength: '',
        productLength: '',
        startLength: '',
        numberOfStartingLengths: '',
        trimLength: '',
        //mail: localStorage.getItem('userName'),
        yearOfManufacture: 2024
      },
      machineTypes: ['SCF-Single', 'SCF-Sigma', 'SCF-Omega'],
      years: [2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024],
      errorMessageIncorrectData: null,
      response: null,
      hssValues: null,
      tctValues: null,
      TCTadvise: null,
      HSSadvise: null,
      NOadvise: null,
      errorMessageSCFSToBigTube: '',
      errorMessageSCFSToBigWidth: '',
      errorMessageSCFSToBigHeight:'',
      errorMessageToManyStartingLengths: '',
      errorMessageToManyStartingLengthsSG: '',
      errorMessageSCFToBigWidth: '',
      errorMessageSCFOToBigTube: '',
      errorMessageSCFOToBigHeight: '',
      errorMessagestartLengthTooHeavy: '',
      errorMessageSCFInsufficentBundleLoaderSpeed: '',
      successMessage: '',
      errorResponse: '',
      isLoading: false,
      submitCount: 0,
      submitTimeout: false,
      currentLanguage: 'en',
      translations: {
        nl: nlTranslations,
        fr: frTranslations,
        en: enTranslations,
        es: esTranslations,
        de: deTranslations,
      },
      hssChartData: null,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            title: {
              display: true,
              text: 'Index'
            }
          },
          y: {
            title: {
              display: true,
              text: 'Cylinder Speed'
            }
          }
        }
      }
    }
  },
  computed: {
    getStrengths() {
      return [  '<450 Mpa', '500 Mpa', '600 Mpa', '750 Mpa', '850 MPa', '>1000 Mpa', 'AISI 300', 'AISI 400', 'Aluminium' ]
    },
    unitLabel() {
      return (!this.inputData.unitSystem || this.inputData.unitSystem === 'metric') ? 'mm' : 'inches';
    },
    maxDimensionsForMachineType() {
      return maxDimensions[this.inputData.machine_type] || { maxHoogteRechthoek: 0, maxWijdte: 0 };
    }
  },
  watch: {
    'inputData.unitSystem'(){
      this.validateDiameter();
    },
    'inputData.machine_type'() {
      this.validateDiameter();
      this.validateMultipleProducts();
    },
    'inputData.width'() {
      this.validateDiameter();
    },
    'inputData.height'() {
      this.validateDiameter();
    },
    'inputData.wall'() {
      this.validateDiameter();
    },

    'inputData.numberOfStartingLengths'(){
      this.validateMultipleProducts();
      this.validateDiameter();
    },
    HSSadvise(newVal) {
      if (newVal) {
        this.prepareChartData()
      }
    }
  },
  methods: {
    async submitData(email) {
    this.isLoading = true; // Start het laden

    const modifiedInputData = {
      ...this.inputData,
      width: Math.round(this.inputData.unitSystem === 'imperial' ? this.inputData.width * 25.4 * 10 : this.inputData.width * 10),
      height: Math.round(this.inputData.unitSystem === 'imperial' ? this.inputData.height * 25.4 * 10 : this.inputData.height * 10),
      wall: Math.round(this.inputData.unitSystem === 'imperial' ? this.inputData.wall * 25.4 * 10 : this.inputData.wall * 10),
      productLength: Math.round(this.inputData.unitSystem === 'imperial' ? this.inputData.productLength * 25.4 * 100 : this.inputData.productLength * 100),
      startLength: Math.round(this.inputData.unitSystem === 'imperial' ? this.inputData.startLength * 25.4 * 100 : this.inputData.startLength * 100),
      trimLength: Math.round(this.inputData.unitSystem === 'imperial' ? this.inputData.trimLength * 25.4 : this.inputData.trimLength)
    };

    try {
      const response = this.inputData.unitSystem === 'imperial'
        ? await axios.post('https://bewowebapirecipetool.azurewebsites.net/api/imperial/recipes/calculateadvise', modifiedInputData)
        : await axios.post('https://bewowebapirecipetool.azurewebsites.net/api/metric/recipes/calculateadvise', modifiedInputData);

      this.response = response.data;
      this.errorMessageIncorrectData = false;

      // Extract HSS and TCT values into separate objects
      this.hssValues = {
        "sawDiameter": response.data.advisedSawbladeDiameterHss,
        "sawThickness": response.data.bladeThicknesHss,
        "minimalSawDiameter": response.data.minimumSawbladediameter,
        "pitch": response.data.toothPitchHss,
        "numberOfTeeth": response.data.numberofTeethHss,
        "speed": response.data.advisedHighSpeedHss,
        //"lowSpeed": response.data.advisedLowSpeedHss,
        "highFeed": response.data.advisedHighFeedHss,
        "lowFeed": response.data.advisedLowFeedHss,
        "standTijdZaagbladMin": response.data.standTijdZaagbladMinHss,
        "standTijdZaagbladMax": response.data.standTijdZaagbladMaxHss,
        "restlength": response.data.restPieceHss,
        "sawtime": response.data.zaagtijdHss,
        "output": response.data.outputHss
        // Add other HSS results here
      };

      this.tctValues = {
        "sawDiameter": response.data.advisedSawbladeDiameterTct,
        "sawThickness": response.data.bladeThicknesTct,
        "minimalSawDiameter": response.data.minimumSawbladediameter,
        "pitch": response.data.toothPitchTct,
        "numberOfTeeth": response.data.numberofTeethTct,
        "speed": response.data.advisedHighSpeedTct,
        //"lowSpeed": response.data.advisedLowSpeedTct,
        "highFeed": response.data.advisedHighFeedTct,
        "lowFeed": response.data.advisedLowFeedTct,
        "standTijdZaagbladMin": response.data.standTijdZaagbladMinTct,
        "standTijdZaagbladMax": response.data.standTijdZaagbladMaxTct,
        "restlength": response.data.restPieceTct,
        "sawtime": response.data.zaagtijdTct,
        "output": response.data.outputTct
        // Add other TCT results here
      };

      if (response.data.outputTct !== 0) {
        this.TCTadvise = true;
      } else {
        this.TCTadvise = false;
      }

      if (response.data.outputHss !== 0) {
        this.HSSadvise = true;
        // Call prepareChartData if outputHss is not zero and cylinderSpeedActValuesHss exists
        if (response.data.cylinderSpeedActValuesHss) {
          this.prepareChartData(response.data.cylinderSpeedActValuesHss);
        } else {
          console.error('cylinderSpeedActValuesHss is missing from the response');
        }
      } else {
        this.HSSadvise = false;
      }

      if (response.data.outputHss == 0 && response.data.outputTct == 0) {
        this.NOadvise = false;
      } else {
        this.NOadvise = true;
      }

    } catch (error) {
      console.error(error);
      if (error.response && error.response.status === 500) {
        // Handle 500 error
        this.errorMessageIncorrectData = "An error occurred. Please try again later."; // Set your custom error message here
        this.response = false;
      } else {
        // Handle other errors
        this.response = false;
        this.errorResponse = true;
      }
    } finally {
      this.isLoading = false; // Stop het laden, ongeacht het resultaat
    }
  },
  prepareChartData(cylinderSpeedActValuesHss) {
    console.log('cylinderSpeedActValuesHss:', cylinderSpeedActValuesHss); // Log data for debugging
    this.hssChartData = {
      labels: Array.from({ length: 150 }, (_, i) => i),
      datasets: [
        {
          label: 'Cylinder Speed Act Values HSS',
          backgroundColor: '#42A5F5',
          borderColor: '#42A5F5',
          data: cylinderSpeedActValuesHss
        }
      ]
    };
    console.log('hssChartData:', this.hssChartData); // Log prepared chart data for debugging
  },
    getUnitForKey(key) {
      const unitMappings = {
        // Example mappings, adjust according to your actual data keys and units
        speed: this.inputData.unitSystem === 'imperial' ? 'inch/m' :'m/min',
        lowFeed: this.inputData.unitSystem === 'imperial' ? 'mil/tooth' :'mm/tooth',
        highFeed: this.inputData.unitSystem === 'imperial' ? 'mil/tooth' :'mm/tooth',
        sawDiameter: this.inputData.unitSystem === 'imperial' ? 'inch' : 'mm', // Dynamically choosing based on unit system
        minimalSawDiameter: this.inputData.unitSystem === 'imperial' ? 'inch' : 'mm', // Dynamically choosing based on unit system
        numberOfTeeth: '',
        standTijdZaagbladMin: 'pieces',
        standTijdZaagbladMax: 'pieces',
        restlength: this.inputData.unitSystem === 'imperial' ? 'inch' : 'mm', // Dynamically choosing based on unit system
        sawtime: 'seconds',
        output: 'pieces per hour',
        pitch:  this.inputData.unitSystem === 'imperial' ? 'inch' : 'mm',
        sawThickness: this.inputData.unitSystem === 'imperial' ? 'inch' : 'mm',
        // Add more mappings as necessary
      };

      return unitMappings[key] || ''; // Return an empty string if no mapping found
    },

    setStrength(index) {
    this.inputData.strength = index;

    },
    toggleSelection(buttonKey) {
      this.inputData[buttonKey] = !this.inputData[buttonKey];
    },
    validateMultipleProducts(){
      this.errorMessageToManyStartingLengths = '';
      this.errorMessageToManyStartingLengthsSG = '';
      if (this.inputData.numberOfStartingLengths > 2 && this.inputData.machine_type === 'SCF-Omega' | this.inputData.machine_type === 'SCF-Single')
      {
        this.errorMessageToManyStartingLengths = `${this.getTranslation('words','for')} ${this.inputData.machine_type}, ${this.getTranslation('notify','max2StartLengths')}`
      }
      if (this.inputData.numberOfStartingLengths > 6 && this.inputData.machine_type === 'SCF-Sigma')
      {
        this.errorMessageToManyStartingLengthsSG = `${this.getTranslation('words','for')} ${this.inputData.machine_type}, ${this.getTranslation('notify','max6StartLengths')}`
      }

    },

    calculateStartlength() {
      const { width, height, solid, shape, wall , unitSystem} = this.inputData;
      let Width, Height, Wall;

      if (unitSystem === 'imperial') {
        Width = width * 25;
        Height = height * 25;
        Wall = wall * 25;
      } else {
        Width = width
        Height = height
        Wall = wall
      }

      let surface = 0;
      let weight = 0;
      let weightStartlength = 0;
      let effectiveWall;

      if (shape === 0) {
        // Round shape
        effectiveWall = solid ? Width / 2 : Wall;
        surface = Math.PI * Math.pow(Width, 2) * 0.25 - Math.PI * Math.pow((Width - effectiveWall * 2), 2) * 0.25;
      } else {
        // Rectangle or square shape
        effectiveWall = solid ? Width / 2 : Wall;
        effectiveWall = solid ? Height / 2 : Wall;
        surface = (Height*Width)-((Height-effectiveWall*2)*(Width-effectiveWall*2));
      }

      weight = surface * 0.00000785;

      weightStartlength = weight * this.inputData.startLength

      return weightStartlength;
    },
    validateDiameter() {
      this.errorMessageSCFSToBigTube = '';
      this.errorMessageSCFSToBigWidth = '';
      this.errorMessageSCFSToBigHeight = '';
      this.errorMessageSCFOToBigTube = '';
      this.errorMessageSCFOToBigWidth = '';
      this.errorMessageSCFOToBigHeight = '';
      this.errorMessagestartLengthTooHeavy = '';

      if (this.inputData.wall > (this.inputData.width / 2)) {
        setTimeout(() => {
          if (this.inputData.wall > (this.inputData.width / 2)) {
            this.inputData.wall = this.inputData.width / 2;
          } else {
          }
        }, 1000);
      } else {
        // doe niks
      }


      const startWeight = Math.round(this.calculateStartlength(),0)

      console.log(startWeight)

      if((this.inputData.machine_type === 'SCF-Single' || this.inputData.machine_type === 'SCF-Sigma') &&  50 < startWeight)
      {
        this.errorMessagestartLengthTooHeavy = `${this.getTranslation('notify','toHeavySCF')} ${this.inputData.machine_type}`
      }

      if(this.inputData.machine_type === 'SCF-Omega' && startWeight > 120)
      {
        this.errorMessagestartLengthTooHeavy = `${this.getTranslation('notify','toHeavySCF')} ${this.inputData.machine_type}`
      }

      const maxDimensionsTable = {
        'SCF-Single': { maxDiameter: this.inputData.unitSystem === 'imperial' ? 90/25 : 90, maxWidthRectangle: this.inputData.unitSystem === 'imperial' ? 80/25 : 80, maxHeightRectangle: this.inputData.unitSystem === 'imperial' ? 80/25 : 80, maxWidth: this.inputData.unitSystem === 'imperial' ? 96/25 : 96 },
        'SCF-Sigma': { maxDiameter: this.inputData.unitSystem === 'imperial' ? 90/25 : 90, maxWidthRectangle: this.inputData.unitSystem === 'imperial' ? 80/25 : 80, maxHeightRectangle: this.inputData.unitSystem === 'imperial' ? 80/25 : 80, maxWidth: this.inputData.unitSystem === 'imperial' ? 96/25 : 96 },
        'SCF-Omega': { maxDiameter: this.inputData.unitSystem === 'imperial' ? 102/25 : 102, maxWidthRectangle: this.inputData.unitSystem === 'imperial' ? 100/25 :100, maxHeightRectangle: this.inputData.unitSystem === 'imperial' ? 80/25 : 80, maxWidth: this.inputData.unitSystem === 'imperial' ? 152/25 : 152 },
      };

      // Calculate total diameter based on the number of tubes
      const totalWidth = this.inputData.width * this.inputData.numberOfStartingLengths;
      const totalHeight = this.inputData.height * this.inputData.numberOfStartingLengths;

      const maxDimensions = maxDimensionsTable[this.inputData.machine_type];
      const unit = (!this.inputData.unitSystem || this.inputData.unitSystem === 'metric') ? 'mm' : 'inches'


      if (this.inputData.numberOfStartingLengths ==1)
      {
        if ((this.inputData.machine_type === 'SCF-Single' || this.inputData.machine_type === 'SCF-Sigma')
            && totalWidth > maxDimensions.maxDiameter && this.inputData.shape == 0 ) { /*diameter max*/
          this.errorMessageSCFSToBigTube = `${this.getTranslation('words','for')} ${this.inputData.machine_type}, ${this.getTranslation('notify','maxDia')} ${maxDimensions.maxDiameter}${unit}`
        }
        if ((this.inputData.machine_type === 'SCF-Single' || this.inputData.machine_type === 'SCF-Sigma')
              && totalWidth > maxDimensions.maxWidthRectangle && this.inputData.shape > 0) { /*rectangle/square max*/
          this.errorMessageSCFSToBigWidth = `${this.getTranslation('words','for')} ${this.inputData.machine_type}, ${this.getTranslation('notify','maxWidth')} ${maxDimensions.maxWidthRectangle}${unit}`
        }
        if ((this.inputData.machine_type === 'SCF-Single' || this.inputData.machine_type === 'SCF-Sigma')
              && totalHeight > maxDimensions.maxHeigtRectangle && this.inputData.shape > 0) { /*rectangle/square max*/
          this.errorMessageSCFSToBigHeight = `${this.getTranslation('words','for')} ${this.inputData.machine_type}, ${this.getTranslation('notify','maxHeight')} ${maxDimensions.maxHeightRectangle}${unit}`
        }
        if (this.inputData.machine_type === 'SCF-Omega'
              && totalWidth > maxDimensions.maxDiameter && this.inputData.shape == 0 ) { /*diameter max omega*/
          this.errorMessageSCFOToBigTube = `${this.getTranslation('words','for')} ${this.inputData.machine_type}, ${this.getTranslation('notify','maxDia')} ${maxDimensions.maxDiameter}${unit}`
        }
        if (this.inputData.machine_type === 'SCF-Omega'
              && totalWidth > maxDimensions.maxWidthRectangle && this.inputData.shape > 0) { /*rectangle/square max omega*/
          this.errorMessageSCFOToBigWidth = `${this.getTranslation('words','for')} ${this.inputData.machine_type}, ${this.getTranslation('notify','maxWidth')} ${maxDimensions.maxWidthRectangle}${unit}`
        }
        if (this.inputData.machine_type === 'SCF-Omega'
              && totalHeight > maxDimensions.maxHeightRectangle && this.inputData.shape > 0) { /*rectangle/square max omega*/
          this.errorMessageSCFOToBigHeight = `${this.getTranslation('words','for')} ${this.inputData.machine_type}, ${this.getTranslation('notify','maxHeight')} ${maxDimensions.maxHeightRectangle}${unit}`
        }
      }
      else
      {
        if ((this.inputData.machine_type === 'SCF-Single' || this.inputData.machine_type === 'SCF-Sigma')
            && totalWidth > maxDimensions.maxWidth && this.inputData.shape == 0 ) { /*diameter max*/
          this.errorMessageSCFSToBigTube = `${this.getTranslation('words','for')} ${this.inputData.machine_type}, ${this.getTranslation('notify','maxDiaMulti')} ${maxDimensions.maxWidth}${unit}`
        }
        if ((this.inputData.machine_type === 'SCF-Single' || this.inputData.machine_type === 'SCF-Sigma')
              && totalWidth > maxDimensions.maxWidth && this.inputData.shape > 0) { /*rectangle/square max*/
          this.errorMessageSCFSToBigWidth = `${this.getTranslation('words','for')} ${this.inputData.machine_type}, ${this.getTranslation('notify','maxWidthMulti')} ${maxDimensions.maxWidth}${unit}`
        }
        if ((this.inputData.machine_type === 'SCF-Single' || this.inputData.machine_type === 'SCF-Sigma')
              && totalHeight > maxDimensions.maxHeigtRectangle && this.inputData.shape > 0) { /*rectangle/square max*/
          this.errorMessageSCFSToBigHeight = `${this.getTranslation('words','for')} ${this.inputData.machine_type}, ${this.getTranslation('notify','maxHeigthMulti')} ${maxDimensions.maxHeightRectangle}${unit}`
        }
        if (this.inputData.machine_type === 'SCF-Omega'
              && totalWidth > maxDimensions.maxWidth && this.inputData.shape == 0 ) { /*diameter max omega*/
          this.errorMessageSCFOToBigTube = `${this.getTranslation('words','for')} ${this.inputData.machine_type}, ${this.getTranslation('notify','maxDiaMulti')} ${maxDimensions.maxWidth}${unit}`
        }
        if (this.inputData.machine_type === 'SCF-Omega'
              && totalWidth > maxDimensions.maxWidth && this.inputData.shape > 0) { /*rectangle/square max omega*/
          this.errorMessageSCFOToBigWidth = `${this.getTranslation('words','for')} ${this.inputData.machine_type}, ${this.getTranslation('notify','maxWidthMulti')} ${maxDimensions.maxWidth}${unit}`
        }
        if (this.inputData.machine_type === 'SCF-Omega'
              && totalHeight > maxDimensions.maxHeigtRectangle && this.inputData.shape > 0) { /*rectangle/square max omega*/
          this.errorMessageSCFOToBigHeight = `${this.getTranslation('words','for')} ${this.inputData.machine_type}, ${this.getTranslation('notify','maxHeigthMulti')} ${maxDimensions.maxHeightRectangle}${unit}`
        }
        if(this.inputData.numberOfStartingLengths > 4 && this.inputData.width < 10)
        {
          this.errorMessageSCFInsufficentBundleLoaderSpeed = `${this.getTranslation('notify', 'InsufficentBundleLoaderSpeed')}`;
          setTimeout(() => {
            this.errorMessageSCFInsufficentBundleLoaderSpeed = '';
          }, 5000);
          this.inputData.numberOfStartingLengths = 4
        }
      }
    },
    setShape(shape) {
      this.inputData.shape = shape;
      this.validateDiameter();
    },
    getTranslation(topic, key) {
      const langTranslations = this.translations[this.currentLanguage];
      if (langTranslations && langTranslations[topic] && langTranslations[topic][key]) {
        return langTranslations[topic][key];
      }
      return key;
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/main';

.container {
  display: flex;
  flex-wrap: wrap; /* Zorgt ervoor dat de kolommen op kleinere schermen onder elkaar komen */
  min-width: 400px; /* Zorgt voor een minimale breedte van de kolom */
}

.column {
  flex: 1; /* Elke kolom krijgt evenveel ruimte */
  margin: 10px;
  padding: 5px;
  border: 3px solid #bbcd13;
  border-radius: 20px;
  background-color: #f1ececc4;
}

.response-content {
  margin-top: 10px;
}

.response-table {
  display: grid;
  grid-template-columns: auto auto;
  gap: 20px 20px;
}

.column1{
  margin: 10px;
  padding: 5px;
  border: 2px solid #bbcd13;
  border-radius: 10px;
}

.response-row {
  display: contents;
  background-color: #fff; /* Match the input's background color */
}

.response-key {
  font-weight: bold;
  text-align: center;
  margin-top: 10px;
  margin-bottom: 20px;
}

.response-value {
  text-align: left;
}

.input-container label {
  font-weight: bold;
  min-width: 140px; /* Adjust the width as needed */
  margin-right: 10px;
  text-align: right;
}

.button-container {
  display: flex;
  align-items: center;
  justify-content: flex-end; /* Align to the right */
  margin-top: 5px; /* Add some top margin if needed */
}

.hss-column {
  float: left;
  padding-right: 10px; /* Add some spacing between columns */
  margin-top: 10px;
  padding: 15px;
  border: 1px solid #bbcd13;
  background-color: #f1ecec93; /* Match the input's background color */
  border-radius: 8px;
}

.tct-column {
  float: left;
  margin-top: 10px;
  padding: 15px;
  margin-left: -10px;
  border: 1px solid #bbcd13;
  background-color: #f1ecec93; /* Match the input's background color */
  border-radius: 8px;
}
/* Add this CSS to your existing styles */

.key-value-container {
  flex: 1; /* Elke kolom krijgt evenveel ruimte */
  display: flex;
  justify-content: space-between;
  border: 1px solid #bbcd13; /* Add border styling */
  background-color: #fff; /* Match the input's background color */
  padding: 5px;
  margin: 5px 0;
  border-radius: 8px;
}

.key {
  font-weight: bold;
}

.value {
  flex-grow: 1;
  text-align: right;
}

.input-container {
  display: flex;
  align-items: center;
  margin-bottom: 0px; /*aangepast vanaf 10px zodat het op 1 pagina past*/
  margin-left: -50px
}

.input-with-unit .input-unit-wrapper {
  display: flex;
  align-items: center;
  position: relative;
  font-weight: bold;
}

.input-with-unit input {
  border-right: none; /* Hide the right border of the input to blend with the unit */
  -moz-appearance: textfield; /* Removes the spinner from input number type in Firefox */
}

.input-with-unit input::-webkit-outer-spin-button,
.input-with-unit input::-webkit-inner-spin-button {
  -webkit-appearance: none; /* Removes the spinner from input number type in WebKit browsers */
  margin: 0;
}
.timeout-message {
  color: red;
  margin: 20px;
  text-align: center;
}

.button {
  background-color: #f4f4f4; /* Light grey background */
  color: #000; /* Black text color */
  border: 1px solid #ddd; /* Light grey border */
  padding: 10px 10px;
  cursor: pointer;
  transition: background-color 1s, color 1s; /* Smooth transition for hover effect */
  border-radius: 10px;
}

.button:hover {
  background-color: #8a970f; /* Slightly darker grey background on hover */
}

.active {
  background-color: #bbcd13; /* Active button background */
  color: white; /* Active button text color */
  border-color: #bbcd13; /* Active button border color */
  border-radius: 10px;
}

.disclaimer{
  margin-left: 50px;
  display: flex;
  align-items: center;
  position: relative;
  font-weight: bold;
  font-size: 12px;
}
</style>
